import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

const InputForm = ({
  value,
  onChange,
  placeholder,
  name,
  type,
  inputmode = 'text',
  error,
  isDisabled = false,
  forceLowecase = false,
  onBlur,
  autoCapitalize = true,
  autoCorrect = true,
  spellCheck = true,
  label,
  splitText,
}) => {
  const [forceToShow, setForceToShow] = useState(false);
  const { t } = useTranslation();

  const renderInput = () => {
    return (
      <input
        className={`wl-input ${splitText ? 'wl-grow' : ''} ${error ? 'error' : ''}`}
        name={name}
        type={forceToShow ? 'text' : type}
        value={forceLowecase ? value?.toLowerCase() : value}
        onChange={onChange}
        disabled={isDisabled}
        onBlur={onBlur}
        autoCapitalize={autoCapitalize ? 'on' : 'off'}
        autoCorrect={autoCorrect ? 'on' : 'off'}
        spellCheck={spellCheck}
        placeholder={placeholder}
        inputMode={inputmode}
      />
    );
  };

  return (
    <div style={{ position: 'relative' }}>
      <label className='wl-label'>{label}</label>

      {splitText ? (
        <div className='wl-split'>
          <span className='wl-fixed'>{splitText}</span>
          {renderInput()}
        </div>
      ) : (
        renderInput()
      )}

      {type === 'password' && value?.length > 0 &&
        (!forceToShow ? (
          <span onClick={() => setForceToShow(true)} className={'wl-show-toggle'}>
            {t('login.showPassword')}
          </span>
        ) : (
          <span onClick={() => setForceToShow(false)} className={'wl-show-toggle'}>
            {t('login.hidePassword')}
          </span>
        ))}
      {error && error.length > 0 && (
        <div className='error-form' style={{ color: '#fff' }}>
          <span></span> {error}
        </div>
      )}
    </div>
  );
};

export default InputForm;
